import { Controller } from "@hotwired/stimulus"

// 出金依頼一覧で pending な依頼を選択して一括でバッチ化するためのコントローラー。
// 選択状態に応じて submit ボタンの有効 / 無効を切り替え、ヘッダのチェックボックスで全選択を切り替える。
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "submit"]

  connect() {
    this.updateSubmitState()
  }

  toggleAll(event) {
    const checked = event.currentTarget.checked
    this.checkboxTargets.forEach((box) => {
      if (!box.disabled) box.checked = checked
    })
    this.updateSubmitState()
  }

  updateSubmitState() {
    const checkedCount = this.checkboxTargets.filter((box) => box.checked).length
    const enabled = checkedCount > 0

    this.submitTargets.forEach((btn) => {
      btn.disabled = !enabled
      btn.classList.toggle("opacity-50", !enabled)
      btn.classList.toggle("cursor-not-allowed", !enabled)
      btn.classList.toggle("cursor-pointer", enabled)
      btn.classList.toggle("hover:opacity-90", enabled)
      btn.dataset.turboConfirm = `選択した ${checkedCount} 件の出金依頼でバッチを作成しますか？`
    })

    if (this.hasSelectAllTarget) {
      const enabledBoxes = this.checkboxTargets.filter((box) => !box.disabled)
      this.selectAllTarget.checked = enabledBoxes.length > 0 && enabledBoxes.every((box) => box.checked)
    }
  }
}
